/**
 * Gallery opens on the product's first picture.
 *
 * Dawn renders the selected variant's picture as the active slide. Once
 * every variant has a picture of its own (needed by the checkout), that
 * would put a composite in front of the studio photo on every visit. This
 * moves the first product picture back to the front — with Dawn's own
 * setActiveMedia, prepend=true, the same call Dawn makes on variant
 * change — so slides and thumbnails end up in the original order.
 *
 * Reads its inputs from its own <script> tag (snippets/gallery-open-first.liquid).
 */
(function () {
  var tag = document.querySelector('script[data-gallery-open-first]');
  if (!tag) return;

  var sectionId = tag.getAttribute('data-section');
  var firstMedia = tag.getAttribute('data-first-media');
  if (!sectionId || !firstMedia) return;

  var target = sectionId + '-' + firstMedia;

  function open() {
    var gallery = document.getElementById('MediaGallery-' + sectionId);
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

    var active = gallery.querySelector('[data-media-id].is-active');
    if (active && active.getAttribute('data-media-id') === target) return;
    if (!gallery.querySelector('[data-media-id="' + target + '"]')) return;

    gallery.setActiveMedia(target, true);
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('media-gallery').then(open);
  } else {
    open();
  }
})();
